import {Helmet} from 'react-helmet-async';
import {Link} from 'react-router-dom';
import '../components/InformationPage.css';

function AboutPage() {
  return (
    <>
      <Helmet>
        <title>About Medical Coding Classes Online | Independent Study Prep</title>
        <meta
          name="description"
          content="Learn about Medical Coding Classes Online, an independent self-paced medical billing and coding education platform built and owned by Leadsurance."
        />
        <link rel="canonical" href="https://medicalcodingclassesonline.com/about" />
      </Helmet>
      <main className="information-page">
        <section className="information-hero">
          <div className="container">
            <span className="eyebrow">About the platform</span>
            <h1>Accessible education for the next generation of healthcare professionals.</h1>
            <p>
              Medical Coding Classes Online provides independent, self-paced foundational
              education for aspiring medical billers, coders, and healthcare professionals.
            </p>
          </div>
        </section>
        <section className="information-section">
          <div className="container information-layout">
            <article className="information-content">
              <h2>Our mission</h2>
              <p>
                Our mission is to make medical billing and coding concepts easier to explore
                before a learner commits to an expensive certification program or formal course.
                We provide clear lessons, interactive flashcards, practice quizzes, and study
                tools that help learners build confidence at their own pace.
              </p>
              <p>
                The platform is designed for independent study. Visitors can begin immediately,
                return to lessons when convenient, and save study progress locally in their browser
                without creating an account.
              </p>
              <h2>Built and owned by Leadsurance</h2>
              <p>
                Medical Coding Classes Online is built and owned by the team at{' '}
                <a href="https://leadsurance.com" target="_blank" rel="noreferrer">
                  Leadsurance
                </a>
                . The Leadsurance team brings nearly 15 years of higher education publishing
                experience, working with partners such as QuinStreet and Ed2Go to connect
                thousands of students with leading higher education programs from some of the
                best-known college brands in the country.
              </p>
              <p>
                That background informs our focus on clear educational content, useful learning
                experiences, and helping prospective students make informed decisions about their
                next step.
              </p>
              <h2>Product leadership</h2>
              <div className="profile-card">
                <strong>Keller Tiemann — Head of Product</strong>
                <p>
                  Keller Tiemann leads product development for Medical Coding Classes Online. His
                  professional background includes building digital education experiences,
                  developing learner-focused products, and translating complex information into
                  practical online tools.
                </p>
                <a
                  href="https://www.linkedin.com/in/kellertiemann/"
                  target="_blank"
                  rel="noreferrer"
                >
                  View Keller Tiemann on LinkedIn
                </a>
              </div>
              <h2>Questions and support</h2>
              <p>
                For questions about the platform, educational content, partnerships, or technical
                support, please contact the Leadsurance team at{' '}
                <a href="mailto:support@leadsurance.com">support@leadsurance.com</a>.
              </p>
              <p>
                You can also use our <Link to="/contact">contact page</Link> to send a support
                request.
              </p>
            </article>
            <aside className="information-aside">
              <span className="aside-label">At a glance</span>
              <h2>Independent foundational education</h2>
              <p>
                Self-paced lessons and interactive study tools for people exploring medical billing
                and coding careers.
              </p>
              <Link to="/#curriculum">Start Studying</Link>
            </aside>
          </div>
        </section>
      </main>
    </>
  );
}

export default AboutPage;